import { TextInput, PhoneInput } from "@/widgets";
import { useApiMutation } from "@/shared/lib/hooks/api";
import {
  LS_I18NEXT_LANG,
  API_SIGN_IN,
  LS_SCHEDULE_SHOW,
  LS_THEME,
  LS_USERDATA,
  LS_TOKEN,
  LS_EMPLOYEE_ID
} from "@/shared/constants";
import { setLoginData, setThemeState } from "../../../store/reducers/LoginSlice";
import { useAppDispatch } from "../../../store/storeHooks";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { parsePhoneNumber } from "@/shared/lib/phoneNumber";
import { 
  Button, 
  Typography, 
  Box, 
  Paper,
} from "@mui/material";

interface ILoginBody {
  phone_number: string;
  password: string;
}

const Login = () => {
  const { control, handleSubmit, setValue, watch } = useForm<ILoginBody>({
    defaultValues: {
      phone_number: "",
      password: ""
    }
  });
  const dis = useAppDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  
  const phoneValue = watch("phone_number");

  const { mutate, status } = useApiMutation<ILoginBody, any>(
    API_SIGN_IN,
    "post",
    {
      onSuccess(data) {
        console.log(data);
        const theme = localStorage.getItem(LS_THEME);
        dis(setThemeState(theme || "light"));
        dis(setLoginData(data?.data));
        toast.success(t("TOAST_MESSAGES.LOGIN_SUCCESS"));

        localStorage.setItem(LS_USERDATA, JSON.stringify(data?.data))
        localStorage.setItem(LS_TOKEN, data?.data?.token);
        localStorage.setItem(LS_EMPLOYEE_ID, data?.data?.employee?._id);

        localStorage.setItem(LS_I18NEXT_LANG, "uz");
        localStorage.setItem(LS_SCHEDULE_SHOW, "class");
        navigate("/");
      },
      onError(error) {
        toast.error(t("TOAST_MESSAGES.LOGIN_ERROR"));
      }
    }
  );

  const submit = (data: ILoginBody) => {
    // Format phone number before sending
    const formattedData = {
      ...data,
      phone_number: parsePhoneNumber(data.phone_number, { type: "withPlusNoSpaces" })
    };
    mutate(formattedData);
  };

  const handlePhoneChange = (value: string) => {
    const formatted = parsePhoneNumber(value, { type: "withPlus" });
    setValue("phone_number", formatted);
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#2162FF',
        padding: 2,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          width: '100%',
          maxWidth: 400,
          borderRadius: 2,
          backgroundColor: 'white',
          padding: 4,
        }}
      >
        <Typography 
          variant="h4" 
          sx={{ 
            textAlign: 'center',
            fontWeight: 600,
            color: '#333',
            mb: 4,
            fontSize: '2rem'
          }}
        >
          Login
        </Typography>

        <form onSubmit={handleSubmit(submit)}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, mb: 3 }}>
            <PhoneInput
              control={control}
              name="phone_number"
              label={t("AUTH.PHONE_NUMBER")}
              placeholder={t("AUTH.PHONE_PLACEHOLDER")}
              onCustomChange={handlePhoneChange}
              variant="default"
              rules={{
                required: { value: true, message: t("AUTH.PHONE_REQUIRED") }
              }}
            />
            
            <TextInput
              control={control}
              name="password"
              type="password"
              label={t("AUTH.PASSWORD")}
              placeholder={t("AUTH.PASSWORD_PLACEHOLDER")}
              variant="default"
              rules={{
                required: { value: true, message: t("AUTH.PASSWORD_REQUIRED") },
                minLength: { value: 6, message: t("VALIDATION.MIN_LENGTH", { min: 6 }) }
              }}
            />
          </Box>

          <Button
            fullWidth
            variant="contained"
            disabled={status === "pending"}
            type="submit"
            sx={{
              py: 1.5,
              backgroundColor: '#2162FF',
              borderRadius: 1,
              textTransform: 'uppercase',
              fontWeight: 600,
              fontSize: '1rem',
              mb: 2,
              '&:hover': {
                backgroundColor: '#1a4fd9',
              },
              '&:disabled': {
                backgroundColor: '#8bb3ff',
              },
            }}
          >
            {status === "pending" ? t("AUTH.LOADING") : t("AUTH.SIGN_IN")}
          </Button>

        </form>

        {/* <Box sx={{ textAlign: 'center' }}>
          <Typography 
            variant="body2" 
            sx={{ 
              color: '#333',
              mb: 1,
              fontSize: '0.9rem'
            }}
          >
            Parolni unutdingizmi?
          </Typography>
        </Box> */}
      </Paper>
    </Box>
  );
};

export default Login;
